export default "__VITE_ASSET__BwOoCx$_i5hBOYwUpPCWig__"